(function($g/*, createjs, lib*/) {
    "use strict";
    /*var Slideshow = $g.Slideshow;
    var CenterBtn = $g.CenterBtn;
    var BottomBar = $g.BottomBar;
    var paral = $g.paral;*/
    var DownloadBtn = require("../components/DownloadBtn");

    function BtnsActions(slideshow, mPlayer, stage) {
        var me = this;
        var bottomBar = this.bottomBar;
        var right = bottomBar.right;
        var btnMenu = right.btnMenu;
        var actionsPreview;
        
        function click() {
          // DOM
          actionsPreview.toggleClass("open");
        }


        function init() {
            actionsPreview = $(".actionsPreview");

            var download = new DownloadBtn(actionsPreview.find(".js-downloadBtn"));
            download.enabled = $g.data.canDownload && !$g.data.isTrial;
            download.ready = $g.data.isReady;

            // canvas
            btnMenu.cursor = "pointer";
            btnMenu.addEventListener("click", click);
            
            var btnShare = actionsPreview.find(".js-shareBtn");
            btnShare.on("click", function() {
                FB.ui({
                    method: 'share',
                    display: 'iframe',
                    href: btnShare.data("href")
                });
            });
            if (!$g.data.isPublic) {
                btnShare.hide();
            }            
        }

        init();
    }

    $g.BtnsActions = BtnsActions;

})(PVPGEngine/*, createjs, lib*/);
